import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  accordions: {
    borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
    paddingX: theme.spacing(1),
    borderRadius: '4px',
    margin: '20px',
    padding: '20px'
  },
}));

export default useStyles;
